const InfoIcon = () => {
    return (
        <img src={process.env.PUBLIC_URL + "/infoIcon.png"} alt="Information" />
    );
}

export default InfoIcon;